import { cn } from '@natu/utils/cn';

const heightClasses = {
  20: 'h-[20%]',
  25: 'h-[25%]',
  30: 'h-[30%]',
  35: 'h-[35%]',
  40: 'h-[40%]',
  45: 'h-[45%]',
  50: 'h-[50%]',
  55: 'h-[55%]',
  60: 'h-[60%]',
  65: 'h-[65%]',
  70: 'h-[70%]',
  75: 'h-[75%]',
  80: 'h-[80%]',
  85: 'h-[85%]',
  90: 'h-[90%]',
  95: 'h-[95%]',
  100: 'h-full',
};

const widthClasses = {
  20: 'md:w-[20%]',
  25: 'md:w-[25%]',
  30: 'md:w-[30%]',
  35: 'md:w-[35%]',
  40: 'md:w-[40%]',
  45: 'md:w-[45%]',
  50: 'md:w-[50%]',
  55: 'md:w-[55%]',
  60: 'md:w-[60%]',
  65: 'md:w-[65%]',
  70: 'md:w-[70%]',
  75: 'md:w-[75%]',
  80: 'md:w-[80%]',
  85: 'md:w-[85%]',
  90: 'md:w-[90%]',
  95: 'md:w-[95%]',
  100: 'md:w-full',
};

export type RecruitmentBarHeight = keyof typeof heightClasses;

export type RecruitmentBarWidth = keyof typeof widthClasses;

export const getRecruitmentBarClasses = (
  height?: RecruitmentBarHeight,
  width?: RecruitmentBarWidth,
): string => cn(height && heightClasses[height], width && widthClasses[width]);
